import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';

export const nutritionistsEntityAdapter = createEntityAdapter({
  selectId: nutritionist => nutritionist._id,
});

export const nutritionistsSlice = createSlice({
  name: 'nutritionists',
  initialState: nutritionistsEntityAdapter.getInitialState(),
  reducers: {
    setNutritionists: nutritionistsEntityAdapter.setAll,
  },
});

export const { setNutritionists } = nutritionistsSlice.actions;
export const nutritionistsReducer = nutritionistsSlice.reducer;
